var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.41803 1.25888C7.8551 -0.0862963 9.75818 -0.0862939 10.1953 1.25889L11.1013 4.04738C11.2968 4.64896 11.8574 5.05626 12.4899 5.05626H15.4219C16.8363 5.05626 17.4244 6.86619 16.2801 7.69756L13.9081 9.42094C13.3963 9.79274 13.1822 10.4518 13.3777 11.0534L14.2837 13.8418C14.7208 15.187 13.1812 16.3056 12.0369 15.4743L9.66485 13.7509C9.15311 13.3791 8.46017 13.3791 7.94843 13.7509L5.5764 15.4743C4.43212 16.3056 2.8925 15.187 3.32958 13.8418L4.23561 11.0534C4.43108 10.4518 4.21695 9.79274 3.70521 9.42094L1.33318 7.69756C0.188898 6.86619 0.776982 5.05626 2.19139 5.05626H5.12338C5.75592 5.05626 6.31653 4.64896 6.51199 4.04738L7.41803 1.25888Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.749b49a11f407f9a7411ab12d6737e98.svg";
export { ForwardRef as ReactComponent };